import grainPrices from "../modules/grain-prices";
import BranchesMap from "../modules/branches-map";
import Form from "../modules/form";

const templateGrain = {
  init() {
    grainPrices.init();
    BranchesMap.init();
    new Form(".form.cform");
  }
};

export default templateGrain;
